import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import { dimensions } from "@styles";

export const toolbar = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
  border-radius: 0 0 ${borders.radiusBase} ${borders.radiusBase};

  padding-left: 1rem;
  padding-right: 1rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-wrap: wrap;
    height: auto;
    padding: 0.25rem 1rem;
  }
`;

export const toolbarButtons = css`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;
